import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import TimeSelector from "../../../components/time-selector";
import { BaseUrlApi, ErrorMessage } from "../../../lib/api";
import axios from "axios";
import { toast } from "sonner";

export default function Schedule() {
  const { language } = useLanguage();

  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchSchedule = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/schedule`);
      setSchedule(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast({ title: "Error", description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchSchedule();
  }, []);

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <h1 className="text-2xl font-bold mb-8">Course Schedule</h1>

      <TimeSelector data={schedule} loading={loading} />
    </div>
  );
}
